<div [formGroup]="form" class="flex items-baseline bg-white rounded-xl px-5 pt-4">
  <span class="text-sm font-semibold mr-24">{{'labels.name' | translate | titlecase}}</span>
  <mat-form-field appearance="outline" class="" hideRequiredMarker>
    <mat-label>{{'labels.name' | translate | titlecase}}</mat-label>
    <input matInput id="input-name" #name="matInput" type="text" formControlName="name" autocomplete="false" maxlength="50">
    <mat-error *ngIf="nameCtrl.invalid" id="{{getErrorMessageElementId('name', nameCtrl)}}">
      {{getErrorMessage(nameCtrl)}}
    </mat-error>
  </mat-form-field>
</div>
